angular.module('bb.external').component('bbExternalListing', {
  bindings: {},
  controller: ExternalListing,
  controllerAs: 'vm',
  template: require('./external_listing.html'),
});

ExternalListing.$inject = [
  '$routeParams',
  'ErrorService',
  'ExternalAuth',
  'ExternalService',
  'ListingViewService',
  'ToastService',
];

function ExternalListing(
  $routeParams,
  ErrorService,
  ExternalAuth,
  ExternalService,
  ListingViewService,
  ToastService,
) {
  const vm = this;
  vm.$onInit = function () {
    const { auth } = ExternalAuth;

    if (
      auth.coopDashboard ||
      auth.retsDashboard ||
      (auth.externalDashboard && auth.listing)
    ) {
      vm.listing = auth.listing;
      vm.assets = ListingViewService.generateAssets(
        vm.listing,
        vm.listing.imageUrls,
      );
      vm.dataLoaded = true;
      return;
    }

    const { listingId } = $routeParams;

    if (!listingId) {
      ToastService.add({
        message: 'Could not load listing: listingId param is missing',
        type: 'danger',
      });
      vm.dataLoaded = true;
      return;
    }

    ExternalService.getExternalListing(auth.dashboardId, listingId)
      .then(({ listing }) => {
        if (!listing) {
          ToastService.add({
            message: 'Could not load listing: Listing might be deleted',
            type: 'danger',
          });
          vm.dataLoaded = true;
          return;
        }

        if (listing.id !== listingId) {
          window.location.href = `/external/#/dash/${auth.dashboardId}/listing/${listing.id}`;
        }

        vm.listing = listing;
        vm.assets = ListingViewService.generateAssets(
          vm.listing,
          vm.listing.imageUrls,
        );
        vm.dataLoaded = true;
      })
      .catch(err => {
        ErrorService.toastyHTTPErr(err);
      });
  };
}

export {};
